/* @flow */
import { names } from 'linaria';

export type ResponsiveValue<T> = {
  small: T,
  medium: T,
  large: ?T,
  xlarge: ?T,
};

export default function Responsive<T>(
  smallValue: T,
  mediumValue: T,
  largeValue?: T,
  xlargeValue?: T
): ResponsiveValue<T> {
  return {
    small: smallValue,
    medium: mediumValue,
    large: largeValue,
    xlarge: xlargeValue,
  };
}

export function responsiveStyles<T>(
  responsiveValue: ResponsiveValue<T>,
  resolver: T => { small: string, medium: string, large: string, xlarge: string }
) {
  let { small, medium, large, xlarge } = responsiveValue;
  let classNames = [];
  if (small) {
    // Don't put small styles in a media query.
    // They serve as the base. If we don't do
    // that the way the media query is written
    // with min-width the styles aren't applied
    // when screen min-width is less than 375
    classNames.push(resolver(small).small);
  }
  if (medium) {
    classNames.push(resolver(medium).medium);
  }
  if (large) {
    classNames.push(resolver(large).large);
  }
  if (xlarge) {
    classNames.push(resolver(xlarge).xlarge);
  }
  return names(...classNames);
}



// WEBPACK FOOTER //
// ./src/ui/constants/Responsive.js